import { Badge, Dropdown } from "react-bootstrap";
import { FileDrive_Funcs } from "./filedriveFuncs";
import React from "react";
import { FileEntry, FolderEntry } from "./filebase";
import { StateTypeContext } from "../clientportal/types";


type CustomToggleProps = {
    children: React.ReactNode;
    onClick: (...arg: any[]) => void;
    faName: string;
    style?: React.CSSProperties;
}
const CustomToggle = React.forwardRef<HTMLInputElement, CustomToggleProps>(
    (props, ref) => (
        <i className={props.faName}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                props.onClick(e);
            }}
            style={(props.style === undefined) ? {} : props.style}>
            {props.children}
        </i>
    ))

type DocumentRowProps = {
    doc: FileEntry;
    renameD: ({ }: { show: boolean, folder?: FolderEntry, doc?: FileEntry }) => void;
    deleteD: ({ }: { show: boolean, folder?: FolderEntry, doc?: FileEntry }) => void;
    moveD: ({ }: { show: boolean, doc: FileEntry }) => void;
    copyD: ({ }: { show: boolean, doc: FileEntry }) => void;
    portalState: StateTypeContext;
    SessionID: string;
    portalService?: any;
    AppID?: string;
    UserID?: string;
    AppCode?: string;
    onPickFile?: (doc: FileEntry) => void;
}
const DocumentRow = ({
    doc,
    renameD,
    deleteD,
    moveD,
    copyD,
    portalState,
    SessionID,
    portalService,
    AppID,
    UserID,
    AppCode,
    onPickFile
}: DocumentRowProps) => {

    const isShareable = doc.ext === 'docx' || doc.ext === 'pdf' || doc.ext === 'zip' || doc.ext === 'txt';

    if (onPickFile) {
        return (
            <tr onClick={() => { if (isShareable) onPickFile(doc); }} style={{ cursor: isShareable ? 'pointer' : 'default' }}>
                <td>
                    {doc.ext === "pdf" ?
                        <i className="fa-solid fa-file-pdf status-pdf"></i> :
                        (doc.ext === "docx" ?
                            <i className="fa-solid fa-file-word status-word"></i> :
                            <i className="fa-solid fa-file"></i>)
                    }
                </td>
                <td>{doc.justName}</td>
                <td>
                    <Badge bg={doc.ext === 'pdf' ? 'danger' :
                        (doc.ext === 'docx' ? 'info' : 'secondary')
                    } pill>{doc.ext}</Badge>
                </td>
                <td>
                    <Badge bg="secondary" text="dark" pill style={{ whiteSpace: "break-spaces" }}>{FileDrive_Funcs.printDateFromNow(doc)}</Badge>
                </td>
                <td className="align-right" onClick={(e) => { e.stopPropagation() }}>
                    {isShareable ?
                        <i className="fa-regular fa-paperclip dropdown" style={{ paddingRight: '15px' }}
                            onClick={() => { onPickFile(doc); }} title="Attach to email"></i> :
                        <i className="fa-regular fa-paperclip status-secondary dropdown" style={{ paddingRight: '15px' }}
                            title="Only PDF, Word, ZIP, and text files can be attached"></i>}
                </td>
            </tr>
        )
    }

    return (
        <tr onClick={() => { FileDrive_Funcs.openDocument(doc, AppCode, UserID, AppID, SessionID,); }}>
            <td>
                {doc.ext === "pdf" ?
                    <i className="fa-solid fa-file-pdf status-pdf"></i> :
                    (doc.ext === "docx" ?
                        <i className="fa-solid fa-file-word status-word"></i> :
                        <i className="fa-solid fa-file"></i>)
                }
            </td>

            <td>{doc.justName}</td>

            <td>
                
                <Badge bg={doc.ext === 'pdf' ? 'danger' :
                    (doc.ext === 'docx' ? 'info' : 'secondary')
                } pill>{doc.ext}</Badge>
            </td>

            <td>
                <Badge bg="secondary" text="dark" pill style={{whiteSpace:"break-spaces"}}>{FileDrive_Funcs.printDateFromNow(doc)}</Badge>
            </td>

            <td className="align-right" onClick={(e) => { e.stopPropagation() }}>
                <i className="fa-regular fa-square-arrow-up-right dropdown"
                    style={{ paddingRight: '15px' }}
                    onClick={() => { FileDrive_Funcs.openDocument(doc, AppCode, UserID, AppID, SessionID,); }}
                    title="Open document in new window"></i>
                <Dropdown drop='start' className="options dropdown">
                    <Dropdown.Toggle as={CustomToggle} faName="fa-regular fa-arrow-down-to-line" style={{ paddingRight: '15px' }} />
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => {
                            FileDrive_Funcs.downloadDocument(doc);
                        }}>Download Document</Dropdown.Item>

                        {doc.ext === 'docx' &&
                            <Dropdown.Item onClick={() => {
                                FileDrive_Funcs.downloadDocumentAsPDF(doc);
                            }}>Download as PDF</Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>
                {!(doc.ext === 'docx' || doc.ext === 'pdf') &&
                    <i className="fa-regular fa-share-nodes status-secondary dropdown"
                        style={{ paddingRight: "15px" }}
                        title="Only Word and PDF files can be shared"></i>}

                {(doc.ext === 'docx' || doc.ext === 'pdf') && AppCode !== 'WILL' &&
                    <Dropdown drop='start' className="options dropdown">
                        <Dropdown.Toggle as={CustomToggle} faName="fa-regular fa-share-nodes" style={{ paddingRight: '15px' }} />
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => {
                                FileDrive_Funcs.emailDocument(doc, SessionID);
                            }}>Email</Dropdown.Item>
                            {portalService && 
                                <Dropdown.Item onClick={() => {
                                    FileDrive_Funcs.shareClientConnect(doc, portalService, portalState);
                                }}>ClientConnect</Dropdown.Item>
                            }
                            {portalService &&
                                <Dropdown.Item onClick={() => {
                                    FileDrive_Funcs.shareRemoteSigning(doc, portalService, portalState);
                                }}>E-signing</Dropdown.Item>
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                }

                <Dropdown drop='start' className="options dropdown">
                    <Dropdown.Toggle as={CustomToggle} faName="fa-regular fa-ellipsis-vertical" />
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => {
                            renameD({ show: true, doc: doc });
                        }}>Rename</Dropdown.Item>

                        <Dropdown.Item onClick={() => {
                            copyD({ show: true, doc: doc });
                        }}>Copy</Dropdown.Item>

                        <Dropdown.Item onClick={() => {
                            moveD({ show: true, doc: doc });
                        }}>Move</Dropdown.Item>

                        <Dropdown.Item onClick={() => {
                            deleteD({ show: true, doc: doc });
                        }}>Delete</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </td>
        </tr>
    )
}

export default DocumentRow;